import { MeiliSearch } from 'meilisearch';
import MeilisearchInput from '@/js/components/Forms/Inputs/MeilisearchInput.js';

export default class SearchFull {
  static instance = undefined;

  rootElement = undefined;
  listElement = undefined;

  meilisearchClient = undefined;

  pageHeaderTitleElement = undefined;
  pageHeaderTitleInitialInnerHTML = '';

  postTypeIndexesQueryParams = [];

  init() {
    this.rootElement = document.querySelector('.search-full');

    if (
      !this.rootElement ||
      !window.meilisearch?.host ||
      !window.meilisearch?.searchKey ||
      !window.meilisearch?.federationMultiSearch ||
      !window.meilisearch?.federationMultiSearch?.postTypeIndexesQueryParams
    ) {
      return;
    }

    this.meilisearchClient = new MeiliSearch({
      host: window.meilisearch.host,
      apiKey: window.meilisearch.searchKey,
    });

    this.listElement = this.rootElement.querySelector(
      '.search-full__card-list'
    );

    this.pageHeaderTitleElement = document.querySelector('.page-header__title');
    this.pageHeaderTitleInitialInnerHTML =
      this.pageHeaderTitleElement.innerHTML;

    const filterForm = this.rootElement.querySelector(
      '.search-full__filter-form'
    );

    const meilisearchInputWrapperElement =
      this.rootElement.querySelector('.meilisearch-input');

    const meilisearchInputElement =
      meilisearchInputWrapperElement.querySelector('input[type="search"]');

    const meilisearchIndexSelectElement = this.rootElement.querySelector(
      '.site-filter select[name="meilisearch_indexes[]"]'
    );

    if (filterForm) {
      filterForm.addEventListener('submit', (event) => {
        event.preventDefault();

        if (meilisearchInputElement) {
          const query = encodeURI(meilisearchInputElement.value.trim());

          window.location.href = `${window.location.protocol}//${window.location.host}/recherche/${query}#filtres`;
        }
      });
    }

    meilisearchIndexSelectElement.addEventListener(
      'addItem',
      (event) => {
        this.postTypeIndexesQueryParams.push(event.detail.value);
        this.initNewSearch(meilisearchInputElement.value);
      },
      window.supportPassive
    );

    meilisearchIndexSelectElement.addEventListener(
      'removeItem',
      (event) => {
        this.postTypeIndexesQueryParams =
          this.postTypeIndexesQueryParams.filter(
            (item) => item !== event.detail.value
          );
        this.initNewSearch(meilisearchInputElement.value);
      },
      window.supportPassive
    );

    const meilisearchInput = new MeilisearchInput(
      meilisearchInputWrapperElement,
      {
        inputElement: meilisearchInputElement,
        resetButtonElement: meilisearchInputWrapperElement.querySelector(
          'button[type="reset"]'
        ),
        onInput: (value) => {
          if (meilisearchInput.isFilled) {
            this.initNewSearch(value);
          } else {
            this.setListMessage(
              window.meilisearch?.locales?.fr_FR?.initSearch || ''
            );
            this.setTitleHitsCount(0);
          }
        },
        onReset: () => {
          this.emptyList();
          this.setListMessage(
            window.meilisearch?.locales?.fr_FR?.initSearch || ''
          );
          this.setTitleHitsCount(0);
        },
      }
    );

    if (!meilisearchInput.inputElement.value.length) {
      this.setListMessage(window.meilisearch?.locales?.fr_FR?.initSearch || '');
      this.setTitleHitsCount(0);
    }

    this.initNewSearch(meilisearchInput.inputElement.value);
  }

  initNewSearch(queryValue) {
    if (!queryValue.length) {
      return;
    }

    this.setIsLoading(true);

    this.lastSearchResponse = undefined;

    this.meilisearchClient
      .multiSearch(this.queryStringToMultiParams(queryValue))
      .then((response) => {
        this.lastSearchResponse = response;

        this.setResultsList(response.hits || []);

        this.setTitleHitsCount(
          response.hits && response.hits.length
            ? response.estimatedTotalHits || 0
            : 0
        );
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
      })
      .finally(() => {
        this.setIsLoading(false);
      });
  }

  setTitleHitsCount(count) {
    if (count) {
      this.pageHeaderTitleElement.innerHTML = `${this.pageHeaderTitleInitialInnerHTML} <strong>(<span class="sr-only">nombre de résultats estimé : </span>${count})</strong>`;
      this.pageHeaderTitleElement.setAttribute(
        'title',
        `Nombre de résultats estimé : ${count}`
      );
    } else {
      this.pageHeaderTitleElement.innerHTML =
        this.pageHeaderTitleInitialInnerHTML;
      this.pageHeaderTitleElement.removeAttribute('title');
    }
  }

  queryStringToMultiParams(q) {
    const queries = [];

    for (let index of Object.keys(
      window.meilisearch.federationMultiSearch.postTypeIndexesQueryParams
    )) {
      if (
        this.postTypeIndexesQueryParams.length &&
        !this.postTypeIndexesQueryParams.includes(index)
      ) {
        continue;
      }

      queries[index] = {};

      queries.push({
        ...window.meilisearch.federationMultiSearch.postTypeIndexesQueryParams[
          index
        ],
        q,
      });
    }

    return {
      federation: {
        limit: 10,
      },
      queries,
    };
  }

  setIsLoading(isLoading) {
    this.rootElement.classList.toggle('meilisearch-is-loading', isLoading);
  }

  setResultsList(resultHits) {
    this.emptyList();

    if (!resultHits.length) {
      this.setListMessage(
        window.meilisearch?.locales?.fr_FR?.noResultsFound || ''
      );

      return;
    }

    for (let hit of resultHits) {
      let {
        postType = 'page',
        postPermalink = '#',
        postTitle = '',
        postExcerpt = '',
      } = hit;

      const postTypeSingularLabel = this.getPostTypeSingularLabel(postType);
      const primaryTaxonomy = this.getPrimaryTaxonomy(hit);
      const separator =
        postTypeSingularLabel &&
        postTypeSingularLabel.length &&
        primaryTaxonomy &&
        primaryTaxonomy.length
          ? ' • '
          : '';

      let description = postExcerpt || '';

      if (description && description.length) {
        description = `<p class="search-result-card__description">${description}</p>`;
      }

      let fakeLink =
        '<span class="search-result-card__fake-action search-result-card__fake-action--link">Lire la suite</span>';
      let fakeButton = '';

      if (postType === 'livres-blancs') {
        fakeLink = '';
        fakeButton =
          '<span class="search-result-card__fake-action search-result-card__fake-action--button">Découvrir le livre blanc</span>';
      }

      this.listElement.insertAdjacentHTML(
        'beforeend',
        `<li class="search-full__card-item search-full__card-item--${postType}">
          <article class="search-result-card search-result-card--${postType} search-full__card search-full__card--${postType}">
            <p class="search-result-card__meta-wrapper">${postTypeSingularLabel}${separator}${primaryTaxonomy}</p>
            <a class="search-result-card__title-wrapper" href="${postPermalink}" title="Accéder à la page dédiée">
              <h2 class="search-result-card__title">${postTitle || ''}</h2>
            </a>
            ${description}
            <div class="search-result-card__action-wrapper">
              ${fakeLink}
              ${fakeButton}
            </div>
          </article>
        </li>`
      );
    }
  }

  getPostTypeSingularLabel(postType) {
    if (
      postType &&
      window?.meilisearch?.locales?.fr_FR?.postType?.singular[postType]
    ) {
      return window.meilisearch.locales.fr_FR.postType.singular[postType];
    }

    return `posType.singular.${postType || 'unknown'}`;
  }

  getPrimaryTaxonomy(hit) {
    let primaryTaxonomySlug = undefined;

    const postTypeTaxonomyMapping = {
      'business-cases': 'secteur-business-cases',
      post: 'category',
      dossiers: 'tag-dossiers',
      guides: 'tag-guides',
      'livres-blancs': 'tag-livres-blancs',
      'nos-outils': 'tag-nos-outils',
      tribunes: 'tag-tribunes',
    };

    if (postTypeTaxonomyMapping[hit.postType]) {
      primaryTaxonomySlug = postTypeTaxonomyMapping[hit.postType];
    }

    if (!primaryTaxonomySlug || !hit[primaryTaxonomySlug]) {
      return '';
    }

    if (Array.isArray(hit[primaryTaxonomySlug])) {
      return '';
    }

    const taxonomies = Object.values(hit[primaryTaxonomySlug]);

    if (!taxonomies || !taxonomies.length) {
      return '';
    }

    return taxonomies[0]?.name || '';
  }

  setListMessage(message) {
    this.emptyList();

    this.listElement.insertAdjacentHTML(
      'beforeend',
      `<li class="search-full__message-item">
        <span class="search-full__message-item-label">${message}</span>
      </li>`
    );
  }

  emptyList() {
    this.listElement.innerHTML = '';
  }
}
